export default __webpack_public_path__ + "static/media/DSC_7369.4d815df2.jpg";